import { localStorageAdapter } from "./LocalStorageAdapter";

export class VideoCommentReportStorage {
  static get storageName() {
    return "vod_reported_comments";
  }

  static get localStorage() {
    return localStorageAdapter(this.storageName);
  }

  static getAll() {
    return JSON.parse(this.localStorage.getItem(this.storageName))
  }

  static getItem(videoId) {
    const items = this.getAll()

    if (items && items[videoId]) {
      return items[videoId]
    } else {
      return []
    }
  }

  static appendItem(videoId, commentId) {
    let reportedComments = this.getAll()

    if (!reportedComments) {
      reportedComments = {}
      reportedComments[videoId] = [commentId]
    } else if (!reportedComments[videoId]) {
      reportedComments[videoId] = [commentId]
    } else {
      reportedComments[videoId].push(commentId)
      reportedComments[videoId] = Array.from(new Set(reportedComments[videoId]))
    }

    this.localStorage.setItem(this.storageName, JSON.stringify(reportedComments))
  }
}
